<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [formGroup]="parentFormGroup" class="form-group">
  <ng-select
    (change)="onChange($event)"
    [items]="data | async"
    bindLabel="name"
    bindValue="id"
    [loading]="loader"
    formControlName="locale_id"
    [typeahead]="input$"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'LOCALE_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
</div>
